import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { BRAND_NAME } from "@/lib/brand";

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ name: "", firm_name: "", email: "", password: "" });
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        try {
            await register(form);
            toast.success("Account created");
            navigate("/app");
        } catch (e) {
            setErr(formatApiError(e.response?.data?.detail) || e.message);
        } finally {
            setLoading(false);
        }
    };

    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
            <div className="w-full max-w-md card-sharp p-8 animate-fade-up shadow-sm">
                <Link to="/" className="font-display text-2xl font-extrabold tracking-tight block mb-6">{BRAND_NAME}</Link>
                <div className="text-xs font-mono uppercase tracking-[0.2em] text-slate-500 mb-2">Start trial</div>
                <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900">Create your firm workspace.</h1>
                <form onSubmit={onSubmit} className="mt-6 space-y-4">
                    <div>
                        <label className="label-sharp">Full name</label>
                        <input className="input-sharp" required value={form.name} onChange={set("name")} data-testid="register-name-input" />
                    </div>
                    <div>
                        <label className="label-sharp">Firm name</label>
                        <input className="input-sharp" value={form.firm_name} onChange={set("firm_name")} placeholder="Optional" data-testid="register-firm-input" />
                    </div>
                    <div>
                        <label className="label-sharp">Email</label>
                        <input type="email" required className="input-sharp" value={form.email} onChange={set("email")} data-testid="register-email-input" />
                    </div>
                    <div>
                        <label className="label-sharp">Password</label>
                        <input type="password" required minLength={6} className="input-sharp" value={form.password} onChange={set("password")} data-testid="register-password-input" />
                    </div>
                    {err && <div className="text-xs text-red-700 bg-red-50 border border-red-200 px-3 py-2 rounded-sm">{err}</div>}
                    <button disabled={loading} className="btn-primary w-full disabled:opacity-60" data-testid="register-submit-button">
                        {loading ? "Creating…" : "Create workspace"}
                    </button>
                </form>
                <div className="text-xs text-slate-500 text-center mt-5">
                    Already have one? <Link to="/login" className="font-semibold text-[#0B2447] hover:underline" data-testid="login-link">Sign in</Link>
                </div>
            </div>
        </div>
    );
}
